import { Link } from 'react-router-dom';
import { ErrorState } from '../../components/ErrorState';
import { PageLoadingState } from '../../components/PageLoadingState';
import { fulfillmentStateLabels, orderProgress } from '../../domain/fulfillment';
import { formatDate, useSiteOrders } from './site-data';

/** Pick lists for the site, open ones first. */
export function SitePickListsTab({ siteId }: { siteId: string }) {
  const { query, orders } = useSiteOrders(siteId);

  if (query.isLoading) return <PageLoadingState label="Loading pick lists…" />;
  if (query.isError) {
    return (
      <ErrorState
        title="Pick lists could not be loaded"
        rpcName="ListFulfillmentOrders"
        onRetry={() => void query.refetch()}
      />
    );
  }

  return (
    <section aria-label="Pick lists for this site">
      {orders.length === 0 ? (
        <p className="empty-note">No pick lists for this site.</p>
      ) : (
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th scope="col">Order</th>
                <th scope="col">State</th>
                <th scope="col">Picked</th>
                <th scope="col">Dispatch</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => {
                const progress = orderProgress(order);
                return (
                  <tr key={order.id}>
                    <th scope="row">
                      <Link to={`/fulfillment/${encodeURIComponent(order.id)}`}>
                        {order.externalReference || `Order ${order.id.slice(0, 8)}`}
                      </Link>
                    </th>
                    <td>{fulfillmentStateLabels[order.state]}</td>
                    <td className="mono">
                      {progress.complete}/{progress.total}
                    </td>
                    <td className="mono">{formatDate(order.dispatchDate)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
